import { AlertCircle } from 'lucide-react'
import { useLandingContentStore, type LandingContentStatus } from './landingContent'

/**
 * Gate de los editores del CMS (landing y páginas legales): bloquea la edición
 * hasta tener el contenido REAL del backend. Sin él, el editor mostraría los
 * defaults y guardarlos pisaría el contenido real de la BD.
 */
export function AdminContentGate({ status }: { status: LandingContentStatus }) {
  if (status === 'loading') {
    return (
      <div role="status" aria-busy="true" className="space-y-3">
        <span className="sr-only">Cargando el contenido…</span>
        <div className="h-8 w-64 animate-pulse rounded bg-surface" />
        <div className="h-4 w-96 max-w-full animate-pulse rounded bg-surface" />
        <div className="mt-6 grid gap-3 sm:grid-cols-2">
          {Array.from({ length: 6 }, (_, i) => (
            <div key={i} className="h-20 animate-pulse rounded-card bg-surface" />
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className="rounded-card border border-line bg-panel p-8 text-center">
      <AlertCircle className="mx-auto size-8 text-danger" />
      <h2 className="mt-3 text-lg font-semibold text-ink">No se pudo cargar el contenido</h2>
      <p className="mt-1 text-sm text-ink-muted">
        Para editar hace falta el contenido real del backend; de lo contrario se
        sobrescribiría con los valores por defecto. Revisa tu conexión y reintenta.
      </p>
      <button
        type="button"
        onClick={() => void useLandingContentStore.getState().load()}
        className="mt-5 inline-flex items-center rounded-lg bg-brand px-4 py-2 text-sm font-semibold text-white"
      >
        Reintentar
      </button>
    </div>
  )
}
